import React from 'react';
import { Text } from '@rsos/base-components';

const EmptyState = () => {
  return (
    <Text size="normal" color="secondaryText" mt={10}>
      No digital alerts enabled
    </Text>
  );
};

export default EmptyState;
